import { Typography } from 'antd';
import type React from 'react';
import styled from 'styled-components';
import { FlexRow } from '../row/FlexRow.tsx';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0px;
  white-space: normal;
  padding-block: 4px;
  line-height: 1.2em;
  .ant-form-item-control && {
    padding-block: 8px;
  }
`;

const Title = styled.div`
  font-weight: 600;
  line-height: 1.2em;
  color: ${({ theme }) => theme.colorText};
`;

const Description = styled(Typography.Text)`
  line-height: 1.2em !important;
  font-size: 0.8em;
  padding-top: 2px;
`;

export interface ISelectOptionContentProps {
  label: React.ReactNode;
  description?: React.ReactNode;
  right?: React.ReactNode;
}

/**
 * Contenuto strutturato per le option di una Select:
 * titolo in grassetto, descrizione secondaria e contenuto opzionale a destra.
 *
 * Per adattare l'altezza della select al contenuto multilinea,
 * aggiungere `style={{ height: 'auto', minHeight: '40px' }}`
 * e `popupMatchSelectWidth` alla `SelectInput`.
 */
export function SelectDetailedOption(props: ISelectOptionContentProps) {
  const { label, description, right } = props;
  return (
    <Wrapper>
      {right ? (
        <FlexRow align="flex-start" gutter={8} right={right}>
          <Title>{label}</Title>
        </FlexRow>
      ) : (
        <Title>{label}</Title>
      )}
      {description && <Description type="secondary">{description}</Description>}
    </Wrapper>
  );
}
